// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abe91a38","726":"63e59fed"}[chunkId] + ".chunk.js";
};